import { OnlineId } from 'model';
import { ManPage } from 'components/ManPage/ManPage';

export function Identity({ identities }: { identities: OnlineId[] }): JSX.Element {
  const width = Math.max(...identities.map((i) => i.name.length));
  return (
    <ManPage
      name="identity"
      manual="Online Presence"
      sections={[
        {
          heading: 'NAME',
          body: 'identity - online presences of Pavel Durov'
        },
        {
          heading: 'ACCOUNTS',
          body: (
            <>
              {identities.map((id, i) => (
                <div key={i}>
                  <a href={id.url} target="_blank" rel="noreferrer">
                    {id.name}
                  </a>
                </div>
              ))}
            </>
          )
        }
      ]}
    />
  );
}
